import type {
  IAnswerWinEmployeeBasedReportResponse,
  IAnswerWinReportQuestionBased,
  IAnswerWinReportQuestionBasedDetail,
} from '@/types/Data'
import type {
  IGetAnswerWinReportEmployeeBased,
  IGetAnswerWinReportExcel,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class AnswerWinReportServices extends BaseService {
  GetAnswerWinReportEmployeeBased(payload: IGetAnswerWinReportEmployeeBased) {
    return this.GET<IAnswerWinEmployeeBasedReportResponse>(
      this.PATHS.GET_ANSWER_WIN_REPORT_EMPLOYEE_BASED,
      payload,
    )
  }

  GetAnswerWinReportQuestionBased(answerWinId: string) {
    return this.GET<IAnswerWinReportQuestionBased[]>(
      this.PATHS.GET_ANSWER_WIN_REPORT_QUESTION_BASED,
      { answerWinId },
    )
  }

  GetAnswerWinReportQuestionBasedDetail(questionId: string) {
    return this.GET<Partial<IAnswerWinReportQuestionBasedDetail>>(
      this.PATHS.GET_ANSWER_WIN_REPORT_QUESTION_BASED_DETAIL,
      { questionId },
    )
  }

  GetAnswerWinReportEmployeeBasedExcel(payload: IGetAnswerWinReportExcel) {
    return this.EXCEL(this.PATHS.GET_ANSWER_WIN_REPORT_EMPLOYEE_BASED_EXCEL, false, payload)
  }

  GetAnswerWinReportQuestionBasedExcel(payload: IGetAnswerWinReportExcel) {
    return this.EXCEL(this.PATHS.GET_ANSWER_WIN_REPORT_QUESTION_BASED_EXCEL, false, payload)
  }
}
